
var article = `
## Material UI

### MODAL 

Para eliminar el borde negro del modal que aparece cuando se enfoca es necesario darle al contenido del mismo un estilo **outline: none**. Esto se aplica al contenido, por ejemplo al componente que rendericemos dentro del Modal.

## Ant Design
`

export default article